import { render, staticRenderFns } from "./Definitions.vue?vue&type=template&id=ec584a10&"
import script from "./Definitions.vue?vue&type=script&lang=js&"
export * from "./Definitions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports